import {createContext} from 'react'

const Data = createContext({entries:[], projects:[], efforts:[], users:[], ideas:[], landing:{}, config:{}});

export default Data;
